export const nightAuditdDawerWidth = "800px";

export const nightAuditTabEnum = [
  "Pending Checkouts",
  "Pending Check-Ins",
  "Settlement",
  "Summary",
];

export const NIGHT_AUDIT_TABLE_HEAD = (activeTAB) => {
  if (activeTAB === 2) {
    return [
      { title: "Invoice Id", width: "20%" },
      { title: "Guest", width: "15%" },
      { title: "Room", width: "10%" },
      { title: "Bill Type", width: "10%" },
      { title: "Total", width: "12.5%" },
      { title: "Deposit", width: "12.5%" },
      { title: "Due", width: "12.5%" },
      { title: "", width: "0%" },
    ];
  } else {
    return [
      { title: "Booking Id", width: "20%" },
      { title: "Guest", width: "15%" },
      { title: "Room", width: "10%" },
      { title: "Meal Plan", width: "10%" },
      { title: "Check-Out", width: "10%" },
      { title: "Total", width: "12.5%" },
      { title: "Deposit", width: "12.5%" },
      { title: "", width: "0%" },
    ];
  }
};

export const getBookedRooms = (allRooms, rooms) => {
  let bookedRoomNumber = [];
  let bookedRoomMapBreakup = {};

  allRooms?.forEach((room) => {
    rooms?.forEach((id) => {
      if (room.id == id) {
        bookedRoomMapBreakup[room.type] = Boolean(
          bookedRoomMapBreakup[room.type]
        )
          ? [...bookedRoomMapBreakup[room.type], room.name]
          : [room.name];

        bookedRoomNumber.push(room.name);
      }
    });
  });

  return bookedRoomNumber;
};

const isValidDateString = (dateString) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  return regex.test(dateString);
};

export const formatNightAuditDate = (dateString) => {
  if (isValidDateString(dateString)) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } else return dateString;
};
